import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../theme/palette';

const style = () =>
  createStyles({
    container: {
      display: 'flex',
      gap: '10px',
      padding: '5px',
      alignItems: 'center',
      backgroundColor: palette.background.underBox,
      borderRadius: palette.borderRadius.default
    },
    emoji: {
      width: '36px',
      height: '36px',
      marginLeft: '5px'
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
